import {CleanHeaderSection} from "@commons/ui/component/Section";
import React from "react";

let PageHeading1 = ({blok}) => <CleanHeaderSection title={blok.Heading}/>

export default PageHeading1
